import { NavigateFunction } from "react-router-dom";

const globalRouter = { navigate: null } 

export default globalRouter